import type { VoteRoomLaunchSendResult } from '../../../../../../services/AnalysisApiClient';

const SEND_FAILED_STATUSES = new Set(['Failed', 'NotFound']);

export function voteRoomLaunchSendFailed(send: VoteRoomLaunchSendResult | null | undefined): boolean {
  if (!send?.items?.length) return false;
  if (send.items.every((i) => i.status === 'NotRequired')) return false;
  return send.items.some((i) => SEND_FAILED_STATUSES.has(i.status));
}

export function summarizeVoteRoomLaunchSend(send: VoteRoomLaunchSendResult | null | undefined): {
  variant: 'success' | 'error' | 'info';
  message: string;
} | null {
  if (!send?.items?.length) return null;

  const sent = send.items.filter((i) => i.status === 'Sent');
  const failed = send.items.filter((i) => i.status === 'Failed' || i.status === 'NotFound');
  const notRequired = send.items.every((i) => i.status === 'NotRequired');

  if (notRequired) {
    return {
      variant: 'info',
      message: 'Vote Room launched. Shareholder approval documents are not required for this run.',
    };
  }

  if (failed.length > 0) {
    const detail = failed.map((i) => `${i.kind}: ${i.error || i.status}`).join('; ');
    return {
      variant: 'error',
      message: `Some shareholder documents failed to send — ${detail}. Contact support if this persists.`,
    };
  }

  if (sent.length > 0) {
    return {
      variant: 'success',
      message: 'DocuSign sent the Shareholder Consent and Disclosure Statement in one envelope.',
    };
  }

  return {
    variant: 'info',
    message: 'Shareholder documents were already sent or not required for this run.',
  };
}
